import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import ButtonDefault from "components/Buttons/ButtonDefault";

import { getVehicle } from "services/http/vehicles";
import SpinnerCentered from "~/components/Loader/SpinnerCentered";
import VehicleDetails from "components/VehicleDetails";

const useStyles = makeStyles((_theme) => ({
  content: {
    padding: 48,
  },
  title: {
    paddingBottom: 32,
  },
}));

const VehicleView = () => {
  const { vehicleId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const classes = useStyles();

  const [values, setValues] = useState({
    animals: false,
    rollator: false,
    wheelchair: false,
    taped: false,
  });

  const [loading, setLoading] = useState(false);

  const handleGetVehicle = useCallback(() => {
    setLoading(true);
    const request = {
      data: {
        id: vehicleId,
      },
    };

    getVehicle(request).then(
      (response) => {
        setValues(response);
        setLoading(false);
      },
      (_errors) => {
        setLoading(false);
      },
    );
  }, [vehicleId]);

  useEffect(() => {
    if (vehicleId && vehicleId >= 0) {
      handleGetVehicle();
    }
  }, [vehicleId, handleGetVehicle]);

  return (
    <Paper className={classes.content} elevation={0} square>
      <Box sx={{ mb: "32px" }}>
        {loading ? <SpinnerCentered /> : <VehicleDetails vehicle={values} />}
      </Box>

      <Grid
        container
        direction="row"
        spacing={1}
        sx={{ justifyContent: "flex-start", alignItems: "center" }}
      >
        <Grid size={12}>
          <ButtonDefault onClick={() => navigate("/dashboard/vehicles/list")}>
            {t("Takaisin")}
          </ButtonDefault>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default VehicleView;
